var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7129 1.11719L12.8848 0.289062C12.8554 0.259984 12.8157 0.243672 12.7744 0.243672C12.7331 0.243672 12.6934 0.259984 12.6641 0.289062L0.287109 12.6621C0.258031 12.6915 0.241719 12.7311 0.241719 12.7725C0.241719 12.8138 0.258031 12.8534 0.287109 12.8828L1.11523 13.7109C1.17578 13.7715 1.27539 13.7715 1.33594 13.7109L13.7109 1.33594C13.7734 1.27734 13.7734 1.17773 13.7129 1.11719ZM2.9375 5.75C4.48828 5.75 5.75 4.48828 5.75 2.9375C5.75 1.38672 4.48828 0.125 2.9375 0.125C1.38672 0.125 0.125 1.38672 0.125 2.9375C0.125 4.48828 1.38672 5.75 2.9375 5.75ZM2.9375 1.53125C3.71289 1.53125 4.34375 2.16211 4.34375 2.9375C4.34375 3.71289 3.71289 4.34375 2.9375 4.34375C2.16211 4.34375 1.53125 3.71289 1.53125 2.9375C1.53125 2.16211 2.16211 1.53125 2.9375 1.53125ZM11.0625 8.25C9.51172 8.25 8.25 9.51172 8.25 11.0625C8.25 12.6133 9.51172 13.875 11.0625 13.875C12.6133 13.875 13.875 12.6133 13.875 11.0625C13.875 9.51172 12.6133 8.25 11.0625 8.25ZM11.0625 12.4688C10.2871 12.4688 9.65625 11.8379 9.65625 11.0625C9.65625 10.2871 10.2871 9.65625 11.0625 9.65625C11.8379 9.65625 12.4688 10.2871 12.4688 11.0625C12.4688 11.8379 11.8379 12.4688 11.0625 12.4688Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.c55c34d7fdbebac940e252e5832ef854.svg";
export { ForwardRef as ReactComponent };